const menu = [
  {
    title: "Danie Glówne",
    image: "/images/main.jpg",
    items: [
      "Rosół z makaronem",
      "Rolada, pieczeń, udko (pałka, podudzie)",
      "Kluski, ziemniaki",
      "Kapusta czerwona, zestaw surówek",
    ],
  },
  {
    title: "Dodatki i bufet",
    image: "/images/buffet.jpg",
    items: [
      "Wędliny, sery",
      "Tortilla, śliwka w boczku",
      "Przekąski w cieście francuskim na ciepło",
      "Melon z szynką szwarcwaldzką",
      "Jajka z majonezem",
      "Jajka z dipem czosnkowym",
      "Carpaccio",
      "Tymbaliki",
      "Sałatki 2 rodzaje",
      "Śledzie",
      "Pieczywo, masło",
      "Babeczki nadziewane",
    ],
  },
  {
    title: "Kolacja do wyboru",
    image: "/images/soups.jpg",
    items: [
      "Barszcz z krokietem",
      "Bogracz",
      "Zupa meksykańska",
      "Zupa cebulowa",
      "Żurek",
    ],
  },
  {
    title: "Napoje i desery",
    image: "/images/desserts.jpg",
    items: [
      "Ciasto (sernik, makowiec, jabłecznik)",
      "Kawa, herbata",
      "Tort własny (osobno płatny)",
      "Napoje w dzbankach bez ograniczeń",
      "Napoje gazowane (osobno płatne)",
    ],
  },
];

export default function MenuSection() {
  return (
    <section className="bg-white py-20 px-6 text-dark">
      <div className="max-w-4xl mx-auto space-y-16">
        {menu.map((section, index) => (
          <div key={index}>
            {/* Tytuł sekcji */}
            <h2 className="text-4xl md:text-6xl font-heading text-center mb-8">
              <span style={{ fontFamily: 'Bhorgcust' }} className="inline-block border-b-4 border-accent px-4 pb-1 ">
                {section.title}
              </span>
            </h2>

            {/* Lista dań */}
<ul className="space-y-4">
  {section.items.map((item, i) => (
    <li
      key={i}
      className="border-b border-gray-200 pb-2 font-body text-base flex items-start gap-2"
    >
      <span className="text-accent text-lg leading-[1.2] mt-[3px]">•</span>
      <span>{item}</span>
    </li>
  ))}
</ul>
          </div>
        ))}
      </div>
    </section>
  );
}
